import { useState, useEffect } from 'react';
import { SimpleInstance } from './instance';
export function useSimple(state) {
    const [_, set_] = useState({});
    useEffect(function () {
        const subContainerInstance = SimpleInstance().containerController.subscribe(state, () => {
            set_({});
        });
        return () => SimpleInstance().containerController.removeSubscription(subContainerInstance);
    }, []);
    return state._value;
}
//# sourceMappingURL=useSimple.js.map